import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '@techsoftware/happay-widgets/RadioGroup';
import TextInput from '@techsoftware/happay-widgets/TextInput';

export default function GstTds({
  isGstApplicable,
  isTdsApplicable,
  handleChange,
  gstType,
  tdsType,
  isGst,
  id,
  gstPercentage,
  tdsPercentage,
  error,
}) {
  const showPercentageInput = isGst ? isGstApplicable : isTdsApplicable;
  return (
    <div className="margin-t-24">
      <RadioGroup
        value={isGst ? isGstApplicable : isTdsApplicable}
        onClick={dt =>
          handleChange(isGst ? 'isGstApplicable' : 'isTdsApplicable', dt)
        }
        radioLabelPlacement="right"
        direction="horizontal"
        label={
          <div>
            Is {isGst ? 'GST' : 'TDS'} applicable?
            <span className="alert-red-color">*</span>
          </div>
        }
        radioButtonWrapperStyle={{ marginRight: '20px' }}
        radioButton={[
          { id: `${id}-yes`, value: true, label: 'Yes' },
          { id: `${id}-no`, value: false, label: 'No' },
        ]}
      />

      {showPercentageInput && (
        <>
          {/* <br />
          <RadioGroup
            value={isGst ? gstType : tdsType}
            onClick={dt => handleChange(isGst ? 'gstType' : 'tdsType', dt)}
            radioLabelPlacement="right"
            direction="horizontal"
            radioButtonWrapperStyle={{ marginRight: '20px' }}
            label={<span>Choose type: <span className="alert-red-color">*</span></span>}
            radioButton={[
              {
                id: `${id}-percentage`,
                value: 'percentage',
                label: 'Percentage',
              },
              { id: `${id}-value`, value: 'value', label: 'Value' },
            ]}
          /> */}
          {showPercentageInput && (
            <TextInput
              id={`${id}-value`}
              floatingLabelText="Percentage"
              required
              hintText="Type Percentage"
              value={isGst ? gstPercentage : tdsPercentage}
              type="number"
              clearMargin
              customInputParentStyle={{
                margin: '20px 0px 30px',
                width: '170px',
              }}
              onChange={(dt, val) =>
                handleChange(isGst ? 'gstPercentage' : 'tdsPercentage', val)
              }
              errorText={error}
              errorType={error && 'error'}
              suffix="%"
              regex={/^\d*\.?\d{0,2}$/}
            />
          )}
        </>
      )}
    </div>
  );
}

GstTds.propTypes = {
  isGst: PropTypes.bool,
};

GstTds.defaultProps = {
  isGst: false,
};
